<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="500px"
        transition="slide-y-transition"
        origin="top center"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Wpisz numer listu przewozowego
                </h1>
            </v-card-title>
            <v-card-text>
                <v-container class="pa-0">
                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                                v-model="value"
                                label="Numer listu"
                                outlined
                                :rules="validRuleOrderName"
                                dense
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Zapisz"
                    :disabled="!canSave"
                    @click="onSave"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { digitsAndCharactersOnly } from '@/utils/customValidators'

export default {
    name: 'SentManuallyDialog',
    props: {
        isOpen: {
            type: Boolean
        },
    },
    data() {
        return {
            value: null,
            validRuleOrderName: [
                value => digitsAndCharactersOnly(value) || 'Dozwolone znaki: cyfry i litery (bez polskich znaków)'
            ],
        }
    },
    validations() {
        const rules = {}

        if (this.value) {
            rules['value'] = {
                required: true,
                value: v => digitsAndCharactersOnly(v)
            }
        }

        return rules
    },
    computed:{
        canSave() {
            return this.value && !this.$v.$invalid
        },
    },
    methods: {
        onSave() {
            this.$emit('on-save', this.value)
            this.onClose()
        },
        onClose() {
            this.value = null
            this.$emit('on-close')
        },
    }
}
</script>
